"use client";
import React, { FC } from "react";
import HeroText, { HeroTextProps } from "./HeroText";
import HeroImage, { HeroImageProps } from "./HeroImage";

export type HeroCenteredProps = HeroTextProps & HeroImageProps & {
  showBackgroundGradient?: boolean;
};

const HeroCentered: FC<HeroCenteredProps> = ({
  title,
  subtitle,
  buttons,
  imageUrl,
  showBackgroundGradient = true,
}) => {
  return (
    <section
      className="w-full pt-6 pb-0"
      aria-label="Introduction and value proposition"
    >
      <HeroText
        title={title}
        subtitle={subtitle}
        buttons={buttons}
      />
      <HeroImage imageUrl={imageUrl} showBackgroundGradient={showBackgroundGradient} />
    </section>
  );
};

export default HeroCentered;

